import React, { useState } from 'react';
import { fileExtension, getThumImage, niceBytes } from '../../../Utils/Common';
import { useDispatch, useSelector } from 'react-redux';
import { setActiveFile, setPopup } from '../../../redux/messageSlice';
import { FaStar } from "react-icons/fa";
import { useParams } from 'react-router-dom';
import { IoShareSocial } from "react-icons/io5";
import AudioFilePlay from './AudioFilePlay';

const MessageFiles = ({ msg, is_secret, is_reply_head }) => {
    const params = useParams()
    const [showAll, setShowAll] = useState(false);
    const toggleShowAll = () => setShowAll(!showAll);
    const files = msg.all_attachment;
    const hasMoreFiles = files?.length > 2;
    const visibleFiles = showAll ? files : files?.slice(0, 2);
    const remainingFilesCount = files?.length - 2;
    const singleFiles = files?.length === 1;

    return (
        files?.length > 0 && (!is_secret || (is_secret && is_reply_head) || (is_secret && params.filter_name === 'private')) ?
            <div className='mediaContainer bg-[#EBEEF5] p-2 rounded-lg darkMode bgSurfaceDarkSec '>
                {visibleFiles.map(file => (
                    // pass current theme to FileDesign so img src can pick light/dark folder
                    <FileDesign singleFiles={singleFiles} key={file.id} file={file} is_reply_head={is_reply_head} />
                ))}

                {hasMoreFiles && (
                    <div className="w-full flex justify-center">
                        <button className="pt-[4px] font-bold attachFileMorePlus !text-[14px] text-teal-600 dark:bg-grey-100 dark:text-teal-600" onClick={toggleShowAll} >
                            {showAll ? 'Show Less' : `+ ${remainingFilesCount} more`}
                        </button>
                    </div>
                )}
            </div>
            : null
    );
};



export const FileDesign = ({ file, singleFiles, is_reply_head = false }) => {
    const dispatch = useDispatch();
    const { user } = useSelector(state => state.message)
    const [showAllTags, setShowAllTags] = useState(false);
    const tags = file.tag_list_details || [];
    const visibleTags = showAllTags ? tags : tags.slice(0, 3);
    const hiddenTagsCount = tags.length - 3;

    const viewFile = (e, file) => {
        if (is_reply_head || e.target.id === "playIcon") return;
        dispatch(setActiveFile(file))
        dispatch(setPopup({ key: 'file_drawer', value: true }))
    }

    // determine which image theme folder to use based on theme string containing 'dark' or 'light'
    const theme = localStorage.getItem('theme') || 'light';
    const themeFolder = theme.indexOf('dark') > -1 ? 'black_theme' : 'light_theme';

    return (
        <div className={`multi_value ${singleFiles ? '!mb-0' : '!mb-2'} !p-0 single_file ${file.id > 1 ? 'mt-2' : ''}`}>

            <div className="w-full h-full relative dark:border dark:border-grey-300 rounded-md flex bg-white dark:bg-transparent">
                <div className={`${file.star?.includes(user?.id) || file.url_short_id ? 'w-[calc(100%-40px)]' : 'w-full'}`}>
                    <div className={`flex relative gap-1 items-center px-3 py-3 w-full`}>
                        <div className='flex items-center w-full gap-2'>
                            <div className="img_holder" onClick={(e) => viewFile(e, file)}>
                                {file.location.includes('blob:') ?
                                    <img src={file.location}
                                        className="!w-max-[100%] !h-max-[100%] object-fill rounded-md"
                                        loading='lazy' alt="img" />
                                    :
                                    <img
                                        src={
                                            file.file_type?.indexOf('image') > -1 && file.file_type?.indexOf('svg') === -1
                                                ? getThumImage(file.location)
                                                : file.file_category?.indexOf('voice') > -1
                                                    ? `/images/${themeFolder}/voice.svg`
                                                    : `/images/${themeFolder}/${fileExtension(file?.originalname)}.svg`
                                        }
                                        loading="lazy"
                                        alt="file ext"
                                        title="sender"
                                        className={`file_ext !w-[100%] !h-[100%] object-fill`}
                                    />
                                }
                            </div>
                            <div className='flex flex-col w-[calc(100%-48px)]' onClick={(e) => viewFile(e, file)}>
                                <p className={`file_name dark:!text-white w-full`}>{file.originalname}</p>
                                <p className="file_size dark:text-white">
                                    <span>{niceBytes(file.file_size)}</span>
                                    {(file.reference_type || file.referenceId) &&
                                        <span className="fileRefHolder">
                                            <span className="fileRef !bg-teal-800"> Ref. {file.reference_type}: {file.referenceId}</span>
                                        </span>
                                    }
                                </p>
                            </div>
                            
                        </div>
                    </div>
                    {(file.file_type?.includes('audio') || file.file_category?.includes('voice')) && (
                        <div className={`w-full`}>
                            <AudioFilePlay url={file.location} width={500} height={75} />
                        </div>
                    )
                    }
                    {
                        visibleTags.length > 0 &&
                        <div className={`p-3 border-t dark:border-none border-t-[#cfd8dc] w-full`}>
                            <div className='flex flex-wrap gap-2'>
                                {visibleTags.map((tag, index) => (
                                    <div
                                        key={tag.tag_id}
                                        className={`pt-1 pb-1 px-2 text-xs rounded text-white`}
                                        style={{ backgroundColor: tag.tag_color }}
                                    >
                                        {tag.title}
                                    </div>
                                ))}
                                {hiddenTagsCount > 0 && !showAllTags && (
                                    <div
                                        className={`py-1 px-2 text-xs rounded bg-[#9A7ECD] text-white cursor-pointer`}
                                        onClick={() => setShowAllTags(true)}
                                    >
                                        + {hiddenTagsCount}
                                    </div>
                                )}
                            </div>
                        </div>
                    }
                </div>

                {
                    file.star?.includes(user?.id) || file.url_short_id ?
                        <div className='border-l w-10 border-l-[#cfd8dc] !h-full pl-1 absolute right-0'>
                            <div className='flex gap-3 flex-col justify-center items-center h-full'>
                                {file.star?.includes(user?.id) && <FaStar className='text-teal-600 dark:text-white' />}
                                {
                                    file.url_short_id &&
                                    <IoShareSocial className='dark:text-white' />
                                }
                            </div>
                        </div>
                        : null
                }

            </div>
        </div >
    )
}

export default MessageFiles;
